import React, { useState, useRef, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { buildLangUrl } from '../i18n';
import { authAPI } from '../lib/api';

const LANGS = [
  { code: 'fr', flag: '🇫🇷', label: 'Français' },
  { code: 'en', flag: '🇬🇧', label: 'English' },
  { code: 'es', flag: '🇪🇸', label: 'Español' },
  { code: 'it', flag: '🇮🇹', label: 'Italiano' },
];

export const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const current = LANGS.find((l) => l.code === i18n.language) || LANGS[0];

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const switchLang = async (code) => {
    localStorage.setItem('padsmash_lang', code);
    if (localStorage.getItem('padsmash_token')) {
      try { await authAPI.updateProfile({ language: code }); } catch { /* non-blocking */ }
    }
    window.location.href = buildLangUrl(code, location.pathname, location.search);
  };

  return (
    <div className="relative" ref={ref} data-testid="language-switcher">
      <button
        onClick={() => setOpen(!open)}
        className="w-8 h-8 sm:w-9 sm:h-9 hover:bg-[#F0F7FA] rounded-lg flex items-center justify-center transition-colors text-lg"
        data-testid="language-switcher-btn"
        aria-label="Changer de langue"
      >
        {current.flag}
      </button>
      {open && (
        <div className="absolute right-0 top-full mt-2 w-40 bg-white rounded-xl shadow-2xl border border-[#E8F4FD] z-[60] overflow-hidden py-1" data-testid="language-switcher-menu">
          {LANGS.map((l) => (
            <button
              key={l.code}
              onClick={() => switchLang(l.code)}
              className={`w-full flex items-center gap-2.5 px-3 py-2 text-sm hover:bg-[#F0F7FA] transition-colors ${l.code === current.code ? 'font-bold text-[#0C63BF] bg-[#F7FAFB]' : 'text-[#033871]'}`}
              data-testid={`lang-option-${l.code}`}
            >
              <span className="text-base">{l.flag}</span> {l.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
